import { differenceInYears } from 'date-fns';

export const isAdolescentPatient = (
    dateOfBirth: string | null | undefined,
    adolescentMinimumAge: number,
    adultMinimumAge: number,
): boolean => {
    if (!dateOfBirth) return false;

    const age = differenceInYears(new Date(), dateOfBirth);
    return age >= adolescentMinimumAge && age < adultMinimumAge;
};
